import urls from 'urls';
const dataTitle = 'RICOH Chatbot Service アプリ連携 管理サイト';

export const Header = () => {
  return (
    <header
      className="rsi-header responsive"
      data-title={dataTitle}
      data-show-admin-mode="false"
      data-help-url={urls.HELP}
    ></header>
  );
};
